const state = () => ({
  cardBackground: "#4caf50",
  topBarMenuName: "",
  level1Menu: [],
  tab: [
    {
      name: "首页",
      path: "/main/desktop",
      query: {},
      active: true,
      icon: "home"
    }
  ],
  tab2: [],
  exincludeList: []
})

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {
  setExincludeList(state, exincludeList) {
    state.exincludeList = exincludeList
  },
  setCardBackground(state, color) {
    state.cardBackground = color
  },
  setLevel1Menu(state, level1Menu) {
    state.level1Menu = level1Menu
  },

  setTab(state, tab) {
    state.tab = tab
  },
  setTabPush(state, tabitem) {
    state.tab.push(tabitem)
  },
  setTabSplice(state, param) {
    state.tab.splice(param.index, param.count)
  },
  setTabActive(state, param) {
    state.tab[param.index]['active'] = param.active
  },
  setTab2Active(state, param) {
    state.tab2[param.index]['active'] = param.active
  },
  setTab2(state, tab2) {
    state.tab2 = tab2
  },
  setTab2Push(state, tabitem) {
    state.tab2.push(tabitem)
  },
  setTab2Splice(state, param) {
    state.tab2.splice(param.index, param.count)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/system.js